import React, { memo } from 'react';
import { optionImagePropTypes } from 'core/propTypes/propTypes';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

export const OptionImage = memo(({ option, isSelected, onClick }) => (
  <div onClick={onClick} className="option-image-wrapper product-option" style={{ width: '60px', height: '60px', borderRadius: '8px' }}>
    <ImageWithBaseApi
      src={option?.url}
      alt="option"
      className={`option-image ${isSelected ? 'ltn__border-primary' : ''}`}
      // className="option-image"
      loadingIconFontSize="20px"
    />
  </div>
));

OptionImage.propTypes = optionImagePropTypes;